/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UpsertKeyRequestBody,
  UpsertKeyRequestBody$Outbound,
  UpsertKeyRequestBody$outboundSchema,
} from "../components/upsertkeyrequestbody.js";

export type UpsertModelProviderKeySecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type UpsertModelProviderKeySecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type UpsertModelProviderKeySecurity = {
  option1?: UpsertModelProviderKeySecurityOption1 | undefined;
  option2?: UpsertModelProviderKeySecurityOption2 | undefined;
};

export type UpsertModelProviderKeyRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  upsertKeyRequestBody: UpsertKeyRequestBody;
};

/** @internal */
export type UpsertModelProviderKeySecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const UpsertModelProviderKeySecurityOption1$outboundSchema:
  z.ZodMiniType<
    UpsertModelProviderKeySecurityOption1$Outbound,
    UpsertModelProviderKeySecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function upsertModelProviderKeySecurityOption1ToJSON(
  upsertModelProviderKeySecurityOption1: UpsertModelProviderKeySecurityOption1,
): string {
  return JSON.stringify(
    UpsertModelProviderKeySecurityOption1$outboundSchema.parse(
      upsertModelProviderKeySecurityOption1,
    ),
  );
}

/** @internal */
export type UpsertModelProviderKeySecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const UpsertModelProviderKeySecurityOption2$outboundSchema:
  z.ZodMiniType<
    UpsertModelProviderKeySecurityOption2$Outbound,
    UpsertModelProviderKeySecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function upsertModelProviderKeySecurityOption2ToJSON(
  upsertModelProviderKeySecurityOption2: UpsertModelProviderKeySecurityOption2,
): string {
  return JSON.stringify(
    UpsertModelProviderKeySecurityOption2$outboundSchema.parse(
      upsertModelProviderKeySecurityOption2,
    ),
  );
}

/** @internal */
export type UpsertModelProviderKeySecurity$Outbound = {
  Option1?: UpsertModelProviderKeySecurityOption1$Outbound | undefined;
  Option2?: UpsertModelProviderKeySecurityOption2$Outbound | undefined;
};

/** @internal */
export const UpsertModelProviderKeySecurity$outboundSchema: z.ZodMiniType<
  UpsertModelProviderKeySecurity$Outbound,
  UpsertModelProviderKeySecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => UpsertModelProviderKeySecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => UpsertModelProviderKeySecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function upsertModelProviderKeySecurityToJSON(
  upsertModelProviderKeySecurity: UpsertModelProviderKeySecurity,
): string {
  return JSON.stringify(
    UpsertModelProviderKeySecurity$outboundSchema.parse(
      upsertModelProviderKeySecurity,
    ),
  );
}

/** @internal */
export type UpsertModelProviderKeyRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  UpsertKeyRequestBody: UpsertKeyRequestBody$Outbound;
};

/** @internal */
export const UpsertModelProviderKeyRequest$outboundSchema: z.ZodMiniType<
  UpsertModelProviderKeyRequest$Outbound,
  UpsertModelProviderKeyRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    upsertKeyRequestBody: UpsertKeyRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      upsertKeyRequestBody: "UpsertKeyRequestBody",
    });
  }),
);

export function upsertModelProviderKeyRequestToJSON(
  upsertModelProviderKeyRequest: UpsertModelProviderKeyRequest,
): string {
  return JSON.stringify(
    UpsertModelProviderKeyRequest$outboundSchema.parse(
      upsertModelProviderKeyRequest,
    ),
  );
}
